import { ChakraBadge, Text, useTheme } from '@vitvio/design-system';
import { FlashCircleIcon, InfoCircleIcon } from '@vitvio/shared-components';
import { graphql, useFragment } from 'react-relay';
import type { TimerContentStatusBadgeFragment$key } from './__generated__/TimerContentStatusBadgeFragment.graphql';

const fragment = graphql`
  fragment TimerContentStatusBadgeFragment on Job {
    scheduleStatus
    durations {
      differenceVsPlannedStopMinutes
    }
  }
`;

interface Props {
  fragmentRef: TimerContentStatusBadgeFragment$key | undefined;
}

function formatDifference(difference: number, status_string: string) {
  if (difference > 0) {
    return `${difference} min ${status_string}`;
  }
  return `${Math.abs(difference)} min ${status_string}`;
}

export function TimerContentStatusBadge({ fragmentRef }: Props) {
  const data = useFragment(fragment, fragmentRef);
  const { getColor, getRadius, getSpacing } = useTheme();

  switch (data?.scheduleStatus) {
    case 'ON_TIME':
      return null;
    case 'AHEAD':
      return (
        <ChakraBadge
          my={'auto'}
          colorScheme="titanWhite"
          display={'flex'}
          gap={getSpacing('2')}
          p={getSpacing('2')}
          px={getSpacing('2')}
          borderRadius={getRadius('md')}
        >
          <FlashCircleIcon boxSize={'16px'} my={'auto'} />{' '}
          <Text my={'auto'} textTransform={'none'}>
            {data?.durations?.differenceVsPlannedStopMinutes
              ? formatDifference(data.durations.differenceVsPlannedStopMinutes, 'ahead')
              : 'AHEAD'}
          </Text>
        </ChakraBadge>
      );
    case 'DELAYED':
      return (
        <ChakraBadge
          my={'auto'}
          color={getColor('fg.warning')}
          bg={getColor('bg.warning')}
          display={'flex'}
          gap={getSpacing('2')}
          p={getSpacing('2')}
          px={getSpacing('2')}
          borderRadius={getRadius('md')}
        >
          <InfoCircleIcon boxSize={'16px'} my={'auto'} />{' '}
          <Text my={'auto'} textTransform={'none'}>
            {data?.durations?.differenceVsPlannedStopMinutes
              ? formatDifference(data.durations.differenceVsPlannedStopMinutes, 'delay')
              : 'DELAYED'}
          </Text>
        </ChakraBadge>
      );
    default:
  }
}
